const SITE_URL = "https://www.airportjourneyplanner.com";

const PAID_PLANNER_PAGES = [
  ["heathrow", "heathrow-airport", "Heathrow Airport", "LHR"],
  ["ema", "east-midlands-airport", "East Midlands Airport", "EMA"],
  ["manchester", "manchester-airport", "Manchester Airport", "MAN"],
  ["gatwick", "gatwick-airport", "Gatwick Airport", "LGW"],
  ["luton", "luton-airport", "Luton Airport", "LTN"],
  ["stansted", "stansted-airport", "Stansted Airport", "STN"],
].map(([airportKey, slug, airportName, airportCode]) => ({
  key: `paid-${airportKey}`,
  type: "paid-airport-planner",
  airportKey,
  airportCode,
  airportName,
  path: `/plan/${slug}`,
  canonicalUrl: `${SITE_URL}/plan/${slug}`,
  title: `${airportName} Journey Planner | Taxi, Rail & Driving`,
  description: `Plan a journey to or from ${airportName}. Add your address and flight, then compare taxi, minibus, rail and self-drive timing and costs.`,
  badge: `Live ${airportName} journey planning`,
  heading: `Plan your complete journey to and from ${airportName}.`,
  intro: `Compare taxi, minibus, rail and self-drive for ${airportName}, with flight-aware timing and the latest available journey conditions.`,
  robots: "index,follow",
  sitemap: { changefreq: "daily", priority: "0.90" },
}));

const ajpPaidPlannerPages = Object.freeze(PAID_PLANNER_PAGES);

function getAjpPaidPlannerPage(key) {
  return ajpPaidPlannerPages.find((page) => page.key === key) || null;
}

module.exports = { ajpPaidPlannerPages, getAjpPaidPlannerPage };
